import { render, staticRenderFns } from "./AddActivitiesModal.vue?vue&type=template&id=11837829&scoped=true"
import script from "./AddActivitiesModal.vue?vue&type=script&lang=js"
export * from "./AddActivitiesModal.vue?vue&type=script&lang=js"
import "./AddActivitiesModal.vue?vue&type=style&index=0&id=11837829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11837829",
  null
  
)

export default component.exports